import { StoreStudent } from "@/store/constants";
import WaitTimer from '@/store/waitTimer';

import { appData } from "@/helpers/global";
import { StudentTeacherService } from "@/services/api/student-teacher";

const module = {
    namespaced: true,
    timer: {
        list: new WaitTimer(StoreStudent.state.list, 24 * 60 * 60),
    },
    state: () => ({
        list: [],
    }),
    mutations: {
        setList(state, data) {
            if (state.list != data) {
                state.list = data;
            }},
    },
    actions: {
        setList(ctx, data) {
            ctx.commit("setList", data);
            module.timer.list.resetLastFetchTime();
        },
        loadList({ state, dispatch }, p) {
            if (p.detect && state.list.length > 0) {
                if (module.timer.list.getLastFetchTime() < p.detect) {
                    p.reset = true;
                }
                else {
                    return;
                }
            }
            if (state.list.length == 0 || p.reset || module.timer.list.isTimeExpired(module.timer.list.timeOut)) {
                StudentTeacherService.ListStudent(function (data) {
                    dispatch("setList", data);
                    p.callback();
                }, p.wait);
            }
            else {
                p.wait();
                p.callback();
            }
        }
    },
    getters: {
        getList(state) {
            if(state.list.length == 0) {
                dispatch("loadList", { callback: function() {}}).then(() => {
                    return state.list;        
                });
            }
            return state.list;
        },
        getId: (state) => (id) => {
            return state.list.find((r) => { return r.id == id });
        }
    }
};
export default module;